// admin.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import axios from 'axios'
import router from '../router/index.js'

let interceptorAdaugat = false   // ← flag în afara store-ului

export const useAdminStore = defineStore('admin', () => {
  const token = ref(localStorage.getItem('admin_token') || null)

  const esteAutentificat = computed(() => !!token.value)

  function seteazaToken (t) {
    token.value = t
    if (t) {
      localStorage.setItem('admin_token', t)
      axios.defaults.headers.common['Authorization'] = `Bearer ${t}`
    } else {
      localStorage.removeItem('admin_token')
      delete axios.defaults.headers.common['Authorization']
    }
  }

  function logout () {
    seteazaToken(null)
    router.push('/admin/login')
  }

  function initAxios () {
    if (token.value) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token.value}`
    }

    if (!interceptorAdaugat) {   // ← înregistrează o singură dată
      interceptorAdaugat = true
      axios.interceptors.response.use(
        response => response,
        error => {
          if (
            error.response?.status === 401 &&
            router.currentRoute.value.path !== '/admin/login'
          ) {
            logout()
          }
          return Promise.reject(error)
        }
      )
    }
  }

  initAxios()

  return { token, esteAutentificat, seteazaToken, logout }
})